(() => {
  const initRegainHeroes = (scope = document) => {
    const heroes = scope.querySelectorAll('.rhh');

    heroes.forEach((hero) => {
      if (hero.dataset.rhhInitialized === 'true') {
        return;
      }

      hero.dataset.rhhInitialized = 'true';
      hero.classList.add('rhh--animations-enabled');

      const showHero = () => {
        hero.classList.add('is-visible');
      };

      const heroRect = hero.getBoundingClientRect();

      const isInitiallyVisible =
        heroRect.top < window.innerHeight &&
        heroRect.bottom > 0;

      if (isInitiallyVisible) {
        requestAnimationFrame(showHero);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        showHero();
        return;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            return;
          }

          showHero();
          observer.disconnect();
        },
        {
          threshold: 0.05,
          rootMargin: '100px 0px'
        }
      );

      observer.observe(hero);
    });
  };

  const initialize = () => {
    initRegainHeroes(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initRegainHeroes(event.target);
  });
})();